import Footer from '@/components/Footer';
import HomepageHeader from '@/components/HomepageHeader';
import Image from 'next/image';

export default function About() {
  return (
    <div className="min-h-screen bg-[#F6EFED] page-transition">
      {/* Header Component */}
      <HomepageHeader />

      {/* Hero Section with Background */}
      <section className="relative h-[600px] flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0">
          <Image
            src="/about-banner.jpg"
            alt="About Female Fitness Finder"
            fill
            className="object-cover"
            priority
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-[#4C3E581A]" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-[1920px] mx-auto h-full flex items-center justify-center absolute bottom-0 left-0 right-0 pt-[180px]">
          <div className="max-w-[842px] text-center">
            <h1 className="font-['Gotham_Rounded',sans-serif] text-[64px] font-bold leading-[76px] tracking-[-4%] text-white mb-10" style={{ marginBottom: '10px' }}>
              About FFF
            </h1>
            <p className="font-['Archivo',sans-serif] text-[20px] font-normal leading-[36px] text-white mb-12 tracking-[3%] max-w-3xl mx-auto" style={{ margin: '0 !important' }}>
              Connecting women with safe, verified, women-only fitness spaces.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content - New Layout */}
      <main className="bg-[#f6efed]">
        <div className="max-w-[1320px] mx-auto px-[80px] py-[100px]">
        {/* Story Section - Image Left, Content Right */}
        <div className="grid lg:grid-cols-[45%_55%] gap-[100px] items-center mb-[80px]">
          {/* Left - Image */}
          <div className="relative h-[720px] rounded-[30px] overflow-hidden">
            <Image
              src="/about-fff.jpg"
              alt="Women working out together"
              fill
              className="object-cover"
            />
          </div>
          
          {/* Right - Content */}
          <div className="space-y-6 pr-[40px]">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-[6px] h-[6px] bg-[#8a7490] rounded-full" />
              <span className="font-['Archivo',sans-serif] text-[16px] font-medium text-[#8a7490] uppercase tracking-wide">About Female Fitness Finder</span>
            </div>
            <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[1.2] mb-8">
              Discover women-only, women-led fitness spaces you can trust
            </h2>
            <div className="space-y-6 text-[#6e6672] text-[18px] leading-[32px] font-['Archivo',sans-serif]">
              <p>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribute of letter, as opposed to using 'Content here, content here', making it look like readable English.
              </p>
              <p>
                Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years.
              </p>
            </div>
          </div>
        </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
